import { render, staticRenderFns } from "./NativeAdMappingsData.vue?vue&type=template&id=fb7acc40"
import script from "./NativeAdMappingsData.vue?vue&type=script&lang=js"
export * from "./NativeAdMappingsData.vue?vue&type=script&lang=js"
import style0 from "./NativeAdMappingsData.vue?vue&type=style&index=0&id=fb7acc40&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports